import React from 'react';
import Footer from './Footer';
import Nav from './Nav';
import './main.css';
import soldierKneeling from './images/PW0006_Soldier_Kneeling.png';
import fistsOfQi from './images/0073_Fists_of_Qi.png';
import dice from './images/3d8.jpg';
import karate from './images/0061_Karate.png';
import { Helmet } from 'react-helmet';


export default class Gameplay extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render () {
    return (
        <>
            <Nav/>
            <Helmet>
                <title>Gameplay | Splintered Symmetry</title>
                <link rel="shortcut icon" href="./images/SS Icon.png" type="image/x-icon" />
                <meta name="description" content="Splintered Symmetry's game mechanics are built around a simple yet powerful system. Characters are described by 8 core Aspects which exist on
                three axes of symmetry: half are physical and the other half are mental, half are aspects of strength and the other half are aspects of finesse,
                half are active and the other half are reactive (which includes the concept of resilience)." />
            </Helmet>
            <main>
              <div className="rotating-banner">
                <div className="banner-panel">
                  <div className="banner-image" style={{backgroundImage: `url(${soldierKneeling})`, backgroundPosition: "center 30%"}}></div>
                  <div className="banner-text">Gameplay</div>
                </div>
              </div>
              

              <p>Splintered Symmetry's game mechanics are built around a simple yet powerful system. Characters are described by 8 core Aspects which exist on
                three axes of symmetry: half are physical and the other half are mental, half are aspects of strength and the other half are aspects of finesse,
                half are active and the other half are reactive (which includes the concept of resilience). So, for example, a character's Brawn is their active
                physical strength, while a character's Awareness is their reactive mental finesse.</p>

                <div className="img-text-wrap reverse-on-big">
                  <img className="paragraph-img half-width" src={fistsOfQi} alt="thugs attack a man with glowing fists" />
        
                <p className="half-width">There are 16 skills, which represent broad roles that a character trains
                  in, such as Fighter, Medic, or Diplomat. Most tests that a character makes pair an aspect with a skill, and the pairings are flexible, giving GMs
                  considerable freedom in the kinds of tests that they call for. Where most systems use the same perception or notice test for everything, Splintered
                  Symmetry adds a welcome nuance to each situation: you might use a Burglar's Awareness test to catch someone trying to sneak past you, an Engineer's
                  Awareness test to find a construction flaw, or a Mage's Awareness test to notice a faint magical residue.</p>
                </div>

              <div className="img-text-wrap">
                <img className="paragraph-img half-width" src={dice} alt="three eight-sided dice" />

                <p className="half-width">The dice system is quick and balanced. The standard roll in the game uses three 8 sided dice and picks out just the middle number. This gives a result
                  from 1 to 8, with high and low values being more rare, but without requiring extra addition. Certain game effects can change the roll to pick out the highest number
                  or the lowest. The range of dice results are balanced with the
                  aspect and skill values (which also range from 1 to 8), making for a system driven more by player choices than by luck.</p>
              </div>

              <div className="img-text-wrap">
                <p>One of the more innovative features of Splintered Symmetry is the boon and curse system. Rather than declaring the details of your PC's actions ahead of time, you make your roll and then use the results to determine how much impact your PC can have on the story.Whenever a character rolls above the difficulty, they earn
                  boons which can be used to purchase additional effects like faster performance, disarming an opponent, hitting multiple targets, or showing off. Players have the opportunity to
                  narrate their successful actions, giving them a more prominent role in the storytelling. Rolling under the difficulty makes
                  a character vulnerable to curses, which the GM uses to purchase additional effects like dropping an item, tripping and falling, or doing something embarrassing.
                  Criticals (a roll of 1 or 8) add to the boons or curses, creating memorable moments at the gaming table.
                </p>

                <img className="paragraph-img half-width" src={karate} alt="a woman performs a karate kick" />
              </div>

            </main>
            <Footer />
        </>
    )
  }
}